import React from 'react';
import type { Control, FieldValues, Path, RegisterOptions } from 'react-hook-form';
import { useController } from 'react-hook-form';

import VNDropdownBase from './VNDropdownBase';
import type { VNDropdownBaseProps } from './VNDropdownBase';

export interface VNDropdownRhfProps<TFieldValues extends FieldValues = FieldValues>
  extends Omit<VNDropdownBaseProps, 'value' | 'onChange' | 'onBlur' | 'error' | 'inputRef'> {
  name: Path<TFieldValues>;
  control: Control<TFieldValues>;
  rules?: RegisterOptions<TFieldValues, Path<TFieldValues>>;
}

const VNDropdownRhf = <TFieldValues extends FieldValues = FieldValues>({
  name,
  control,
  rules,
  multiple,
  ...baseProps
}: VNDropdownRhfProps<TFieldValues>) => {
  const {
    field: { value, onChange, onBlur, ref },
    fieldState: { error },
  } = useController({
    name,
    control,
    rules,
    defaultValue: (multiple ? [] : null) as any,
  });

  return (
    <VNDropdownBase
      {...baseProps}
      name={name}
      multiple={multiple}
      value={value ?? (multiple ? [] : null)}
      onChange={onChange}
      onBlur={onBlur}
      error={error?.message}
      inputRef={ref}
    />
  );
};

export default VNDropdownRhf;
